"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _withResponsive = _interopRequireDefault(require("01_core/hooks/withResponsive"));
var _WrapTable = _interopRequireDefault(require("01_core/components/layout/WrapTable"));
var _windowUtil = _interopRequireDefault(require("../../logics/windowUtil"));
var _Pagination = _interopRequireDefault(require("./module/Pagination"));
var _ScrollerTable = _interopRequireDefault(require("./module/ScrollerTable"));
var _WindowScrollerTable = _interopRequireDefault(require("./module/WindowScrollerTable"));
var _ListTable = _interopRequireDefault(require("01_core/components/layout/module/ListTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const COLUMN_DATAKEY_ACTIONS = 'actions';

/**
 * ページング一覧表示部品
 * @prop {string, object} title - タイトル
 * @prop {array} columns - カラム情報
 * @prop {string} columns.dataKey - データキー(rowDataの属性名と一致させる)<br/>
 *  'actions'を指定した列はボタン表示列として幅が固定化される
 * @prop {node} columns.label - ヘッダに表示するラベル
 * @prop {number} columns.width - 列幅の割合（描画時のwidthはウィンドウサイズに応じて自動計算される）
 * @prop {array} rowData - 一覧に表示するデータの配列
 * @prop {func} createRow - データからデータキーを属性名とするコンポーネントオブジェクトを作成する<br/>
 *  シグネチャ:(rowData[index]:object): object{[データキー]:コンポーネント,...}
 * @prop {object} paging - ページング情報
 * @prop {number} paging.viewNum - 表示件数の選択値
 * @prop {number} paging.currentPage - 現在ページ位置
 * @prop {string} [paging.orderBy] - ソートキー
 * @prop {string} [paging.order] - ソート順
 * @prop {func} changeCurrentPage - pagingのcurrentPageを変更する関数<br/>
 *　シグネチャ:(nextPage:number): void
 * @prop {func} changeViewNum - pagingのviewNumを変更する関数<br/>
 *　シグネチャ:(viewNum:number): void
 * @prop {bool} showAll - 全て表示の状態
 * @prop {string} showAllLabel - 全て表示のラベル（変更したい場合）
 * @prop {func} changeShowAll - 全て表示を変更する関数
 * @prop {array} actions - 一覧下部に表示するアクション用コンポーネント
 * @prop {object} [scrollTop] - スクロール位置
 * @prop {number} [scrollTop.index] - スクロール位置(行のindex)
 * @prop {number} [scrollTop.scrollY] - スクロール位置(window.scrollY)
 * @prop {bool} [scrollTop.noSticky] - スクロール位置保持時ヘッダ固定されていなかった場合true
 * @prop {func} [onScroll] - スクロール時のイベント <br/>
 *　シグネチャ:( {index:number,scrollY:number,noSticky:bool }): void
 * @prop {any} [scrollCustomElement] - DOM要素内でスクロールさせるときに指定する
 * @prop {number} [headerHeight] - ヘッダの高さ
 * @prop {bool} [putTypography] -セルをTypographyコンポーネントで囲う場合true
 * @prop {number} [customActionWidth] -一覧内に表示するボタン領域の横幅
 * @prop {bool} isNewWindow - 別ウィンドウ等でヘッダーを必要としない画面の場合trueを指定する（headerBarHeightを0にする）
 * @prop {bool} [reload] -検索ボタン押下以外で一覧の内容を変更する場合true
 * @prop {string, object} help - ヘルプ
 * @prop {bool} enableAccordion - アコーディオン有効フラグ
 * @prop {bool} disableStickyHeader - リストヘッダの移動を無効にする
 */
class LayoutPagingTable extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleChangePage", (page, pure) => {
      this.props.changeCurrentPage(page);
      if (!pure) {
        _windowUtil.default.scrollAboveElement(this.area, this.props.isNewWindow);
      }
    });
    _defineProperty(this, "handleChangeScrollerTable", (page, pure) => {
      this.props.changeCurrentPage(page);
      if (!pure) {
        _windowUtil.default.scrollAboveElement(this.area, this.props.isNewWindow);
        _windowUtil.default.elementScrollTop(this.area);
      }
    });
    _defineProperty(this, "handleChangeShow", showAll => {
      this.props.changeShowAll(showAll);
      _windowUtil.default.scrollAboveElement(this.area);
    });
    _defineProperty(this, "_getDisplayRowData", () => {
      const {
        rowData,
        paging
      } = this.props;
      return rowData.slice(paging.currentPage * paging.viewNum, paging.currentPage * paging.viewNum + paging.viewNum);
    });
  }
  render() {
    const {
      className,
      title,
      paging,
      changeViewNum,
      columns,
      rowData,
      createRow,
      headerHeight,
      putTypography,
      onScroll,
      scrollTop,
      actions,
      showAll,
      showAllLabel,
      changeShowAll,
      scrollCustomElement,
      actionWidth,
      isNewWindow,
      reload,
      width,
      help,
      enableAccordion,
      disableStickyHeader
    } = this.props;
    const normalizedTitle = title;
    if (disableStickyHeader) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_WrapTable.default, {
        title: normalizedTitle,
        help: help,
        actions: actions,
        enableAccordion: enableAccordion
      }, /*#__PURE__*/_react.default.createElement(_Pagination.default, {
        total: rowData.length,
        limit: paging.viewNum,
        currentPage: paging.currentPage,
        handleChangePage: this.handleChangeScrollerTable,
        handleViewNumChange: changeViewNum,
        showAll: showAll,
        showAllLabel: showAllLabel,
        changeShowAll: changeShowAll && this.handleChangeShow
      }), /*#__PURE__*/_react.default.createElement(_ListTable.default, {
        responsiveDisp: true,
        height: 280,
        headerHeight: headerHeight,
        columns: columns,
        createRow: createRow,
        rowData: this._getDisplayRowData(),
        putTypography: putTypography,
        reload: reload,
        useMaxHeight: true
      })));
    } else if ('xs' === width) {
      this._headerBarHeight = isNewWindow ? 0 : 80;
      let _width = 0;
      let _actionWidth = actionWidth || 64;
      columns.forEach(item => {
        if (item.dataKey === COLUMN_DATAKEY_ACTIONS) {
          if (item.direction === 'row') {
            _width += item.label.length * _actionWidth + 8 * 2;
          } else {
            _width += _actionWidth + 8 * 2;
          }
        } else {
          _width += item.width;
        }
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: ref => this.area = ref,
        style: {
          overflow: 'auto',
          width: '100%',
          minWidth: 0
        }
      }, rowData.length !== 0 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: _width,
          height: window.innerHeight - this._headerBarHeight
        }
      }, /*#__PURE__*/_react.default.createElement(_WrapTable.default, {
        title: normalizedTitle,
        help: help,
        className: className,
        actions: actions,
        enableAccordion: enableAccordion
      }, /*#__PURE__*/_react.default.createElement(_ScrollerTable.default, {
        columns: columns,
        rowData: this._getDisplayRowData(),
        createRow: createRow,
        tableWidth: _width,
        headerHeight: headerHeight,
        putTypography: putTypography,
        reload: reload,
        stickyContents: /*#__PURE__*/_react.default.createElement(_Pagination.default, {
          total: rowData.length,
          limit: paging.viewNum,
          currentPage: paging.currentPage,
          handleChangePage: this.handleChangeScrollerTable,
          handleViewNumChange: changeViewNum,
          showAll: showAll,
          showAllLabel: showAllLabel,
          changeShowAll: changeShowAll && this.handleChangeShow
        }),
        stickyContentsHeight: 56,
        striped: true,
        columnPadding: true,
        actionWidth: actionWidth
      }))));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: ref => this.area = ref,
        style: {
          width: '100%',
          minWidth: 0
        }
      }, rowData.length !== 0 && /*#__PURE__*/_react.default.createElement(_WrapTable.default, {
        title: normalizedTitle,
        help: help,
        className: className,
        actions: actions,
        enableAccordion: enableAccordion
      }, /*#__PURE__*/_react.default.createElement(_WindowScrollerTable.default, {
        columns: columns,
        rowData: this._getDisplayRowData(),
        createRow: createRow,
        headerHeight: headerHeight,
        putTypography: putTypography,
        onScroll: onScroll,
        reload: reload,
        scrollTop: scrollTop,
        isNewWindow: isNewWindow,
        stickyContents: /*#__PURE__*/_react.default.createElement(_Pagination.default, {
          total: rowData.length,
          limit: paging.viewNum,
          currentPage: paging.currentPage,
          handleChangePage: this.handleChangePage,
          handleViewNumChange: changeViewNum,
          showAll: showAll,
          showAllLabel: showAllLabel,
          changeShowAll: changeShowAll && this.handleChangeShow
        }),
        stickyContentsHeight: 56,
        striped: true,
        columnPadding: true,
        actionWidth: actionWidth,
        scrollCustomElement: scrollCustomElement
      })));
    }
  }
}
LayoutPagingTable.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    dataKey: _propTypes.default.string.isRequired,
    width: _propTypes.default.number,
    align: _propTypes.default.string,
    className: _propTypes.default.string
  })).isRequired,
  rowData: _propTypes.default.array.isRequired,
  createRow: _propTypes.default.func.isRequired,
  paging: _propTypes.default.shape({
    viewNum: _propTypes.default.number.isRequired,
    currentPage: _propTypes.default.number.isRequired
  }).isRequired,
  changeCurrentPage: _propTypes.default.func.isRequired,
  changeViewNum: _propTypes.default.func.isRequired,
  showAll: _propTypes.default.bool,
  showAllLabel: _propTypes.default.string,
  changeShowAll: _propTypes.default.func,
  actions: _propTypes.default.arrayOf(_propTypes.default.node),
  scrollTop: _propTypes.default.shape({
    index: _propTypes.default.number,
    scrollY: _propTypes.default.number,
    noSticky: _propTypes.default.bool
  }),
  onScroll: _propTypes.default.func,
  scrollCustomElement: _propTypes.default.any,
  headerHeight: _propTypes.default.number,
  putTypography: _propTypes.default.bool,
  actionWidth: _propTypes.default.number,
  isNewWindow: _propTypes.default.bool,
  reload: _propTypes.default.bool,
  help: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  enableAccordion: _propTypes.default.bool,
  disableStickyHeader: _propTypes.default.bool
};
var _default = exports.default = (0, _withResponsive.default)(LayoutPagingTable);